import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/ducks';

import './styles.scss';

export const Coverage: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.email && user?.email !== "ccareadm@mafrahospitalar.com.br") {
      navigate("/cotacoes-dashboard");
    }
  }, [user]);

  return (
    <iframe
      width="100%"
      className="iframe-coverage"
      src="https://customercaredev.blob.core.windows.net/customercare/Coverage/index.html" />
  );
};